import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../services/authentication.service';

@Component({
    selector: 'app-home-layout',
    templateUrl: './page-layout.component.html',
    styleUrls: ['./page-layout.component.css']
})
export class PageLayoutComponent {

}



// WEBPACK FOOTER //
// C:/Users/Pablo/source/repos/prote/angular/src/app/core/layouts/page-layout.component.ts